export const inPx = num => `${num}px`;